import emptyBrandVoiceImage from 'assets/brand-voice/megaphone.png';
import styled from 'styled-components';

type Props = {
  thumbnailUrl?: string;
  /**
   * The size in pixel, will be used for width & height
   */
  size?: number;
};

export const BrandVoiceThumbnailAvatar = ({ thumbnailUrl, size = 24 }: Props) => (
  <StyledImg src={thumbnailUrl || emptyBrandVoiceImage} $size={size} />
);

const StyledImg = styled.img<{ $size: number }>`
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  outline: ${({ theme }) => `1px solid ${theme.colors.commonBlackFocusvisible}`};
  border-radius: 50%;
  object-fit: cover;
`;
